function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48,
  r: 48,
  fill: "#579862"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.1724 27.1877C44.4934 26.4655 45.2096 26 46 26C48.1217 26 50.1566 26.8429 51.6569 28.3431C53.1571 29.8434 54 31.8783 54 34V40H63.3098C64.1753 39.992 65.0323 40.1713 65.8221 40.5258C66.6156 40.8819 67.3222 41.4063 67.8929 42.0627C68.4637 42.719 68.8849 43.4916 69.1274 44.3269C69.3699 45.1622 69.4279 46.0402 69.2974 46.9001L66.5374 64.8999C66.5373 64.9004 66.5375 64.8993 66.5374 64.8999C66.3201 66.33 65.5933 67.635 64.4911 68.5719C63.3916 69.5064 61.9923 70.0134 60.5496 70H32C30.4087 70 28.8826 69.3679 27.7574 68.2426C26.6321 67.1174 26 65.5913 26 64V50C26 48.4087 26.6321 46.8826 27.7574 45.7574C28.8826 44.6321 30.4087 44 32 44H36.7003L44.1724 27.1877ZM40 46.4244L47.2157 30.1892C47.8184 30.3815 48.3727 30.7159 48.8284 31.1716C49.5786 31.9217 50 32.9391 50 34V42C50 43.1046 50.8954 44 52 44H63.32L63.3426 43.9999C63.6326 43.9966 63.9197 44.0564 64.1842 44.1751C64.4487 44.2938 64.6843 44.4686 64.8745 44.6874C65.0648 44.9062 65.2052 45.1637 65.286 45.4421C65.3667 45.7203 65.3861 46.0127 65.3428 46.2991C65.3428 46.2988 65.3427 46.2993 65.3428 46.2991L62.5826 64.3001C62.5103 64.777 62.268 65.2117 61.9005 65.5241C61.533 65.8365 61.0649 66.0056 60.5826 66.0001L40 66V46.4244ZM36 66V48H32C31.4696 48 30.9609 48.2107 30.5858 48.5858C30.2107 48.9609 30 49.4696 30 50V64C30 64.5304 30.2107 65.0391 30.5858 65.4142C30.9609 65.7893 31.4696 66 32 66H36Z",
  fill: "white"
});

var SvgDialogSuccess = function SvgDialogSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDialogSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dialog-success.9da17e74.svg";
export { ForwardRef as ReactComponent };